// THE ADDRESSES WAITING FOR HIS APPROVAL, AT THE REGISTER'S TOP (his "propsed address gets hidden in the web of addresses",
// 4 Nov 2026: Wallet Test's proposed payout address sat as one "Proposed" row near the bottom of 48). One line — how many,
// then each owner and its short address, a tap that opens that row where Approve payout is. Nothing when none wait. Both
// consoles draw it in their own frame.
import type { RegisterWallet } from '../../../lib/api';
import { shortAddress } from '../../kit';
import { awaitsOwner, waitingWords } from './view';

export const waitingOf = (wallets: readonly RegisterWallet[]): RegisterWallet[] => wallets.filter(awaitsOwner);

export function WaitingLine({ waiting, onOpen }: { waiting: readonly RegisterWallet[]; onOpen: (w: RegisterWallet) => void }) {
  return (
    <span className="flex flex-wrap items-baseline gap-x-2 gap-y-1" data-waiting={waiting.length}>
      <span className="font-medium">{waitingWords(waiting.length)}</span>
      {waiting.map((w) => (
        <span key={w.id} className="inline-flex items-baseline gap-2">
          <span aria-hidden className="text-tg-hint">·</span>
          <button type="button" className="tap-44 btn-link text-body" data-waiting-row={w.id} onClick={() => onOpen(w)}>
            {w.party_name ?? w.party_slug} <span className="whitespace-nowrap font-mono">{shortAddress(w.address)}</span>
          </button>
        </span>
      ))}
    </span>
  );
}
